<template>
    <b-modal
        class="clean-modal new-organization-modal"
        :id="`organization-assignment-edit-folder-${folderIn.id}`"
        :ref="`organization-assignment-edit-folder-${folderIn.id}`"
        :title="$t('organization.edit_map')"
        :ok-title="$t('common.save')"
        ok-variant="primary"
        :ok-disabled="title === null"
        @ok="onOk"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal"
        size="sm">
        <b-alert
            v-if="hasError"
            variant="danger"
            show>
            {{ $t('lesson_module.exercise_name_cannot_be_empty') }}
        </b-alert>

        <b-form-input v-model="title"></b-form-input>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-organization-assignment-show-edit-folder-component',
    props: {
        folderIn: Object,
    },
    data() {
        return {
            title: this.folderIn.name,
            hasError: false,
        };
    },
    methods: {
        onOk() {
            this.hasError = this.title === null || this.title === '';

            if (!this.hasError) {
                this.$emit('update-folder', this.folderIn.id, this.title);
            }
        },
    },
};
</script>

<style scoped></style>
